export default __webpack_public_path__ + "static/media/asatocontest-darryl-syms.d0ed7796.mp4";